<header class="layout-grid">
  <mat-toolbar fixedInViewPort>
    <div class="header__logo">
      <a [routerLink]="homeLink"><img [src]="logo" alt="Teller Online Admin Portal"></a>
    </div>
    <nav aria-label="Primary" class="navigation" data-guide="admin-nav">
      @if (authService.isAuthenticated) {
        @if (!appService.currentPage('/config')) {
          <a matButton
            routerLink="/payments"
            data-guide="admin-payments"
            routerLinkActive="navigation-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="navigation-link"
            [attr.aria-current]="appService.ariaCurrent('/payments', true)">
            <mat-icon>payments</mat-icon>
            <span>Payments</span>
          </a>
          @if (siteMetadataService.scheduledPaymentsEnabled) {
            <a matButton
              routerLink="/scheduled-payments"
              data-guide="admin-schedules"
              routerLinkActive="navigation-link--active"
              class="navigation-link"
              [attr.aria-current]="appService.ariaCurrent('/scheduled-payments')">
              <mat-icon>event_repeat</mat-icon>
              <span>Schedules</span>
            </a>
          }
          @if (siteMetadataService.authenticationEnabled) {
            <a matButton
              routerLink="/users"
              data-guide="admin-users"
              routerLinkActive="navigation-link--active"
              class="navigation-link"
              [attr.aria-current]="appService.ariaCurrent('/users')">
              <mat-icon>person</mat-icon>
              <span>Users</span>
            </a>
          }
          <button matButton
            [matMenuTriggerFor]="profilenav"
            class="navigation-group"
            [ngClass]="{'navigation-group--active': appService.currentPage('/profile')}">
            <mat-icon>logout</mat-icon>
            {{ (authService.currentUser$ | async).name }}
            <!-- Without iconPositionEnd, MDC buttons project every mat-icon into the leading slot,
            which reorders the arrow ahead of the name -->
            <mat-icon iconPositionEnd>expand_more</mat-icon>
          </button>
          <mat-menu #profilenav="matMenu" class="navigation">
            <button mat-menu-item (click)="onClick_signOut()"
              class="navigation-link">Sign Out</button>
          </mat-menu>
        }
        @if (appService.currentPage('/config')) {
          <button matButton
            [matMenuTriggerFor]="importexport"
            class="navigation-group">
            <mat-icon>settings</mat-icon>
            Import/Export Config
            <mat-icon iconPositionEnd>expand_more</mat-icon>
          </button>
          <mat-menu #importexport="matMenu">
            <button mat-menu-item (click)="onClick_import()">Import</button>
            <button mat-menu-item (click)="onClick_export()">Export</button>
          </mat-menu>
          <button matIconButton
            (click)="onClick_help()"
            class="help-button"
            aria-controls="help-sidebar"
            [attr.aria-expanded]="helpOpened"
            aria-label="Help"
            matTooltip="Help">
            <mat-icon>help</mat-icon>
          </button>
        }
      }
    </nav>
  </mat-toolbar>
</header>
